import one from "../Images/Strategies/01-problem-statement.png";
import two from "../Images/Strategies/02-determine-goals-and-objectives.png";
import three from "../Images/Strategies/03-choosing-research-methods.png";
import four from "../Images/Strategies/04-establish-a-timeline.png";
import five from "../Images/Strategies/05-user-research.png";
import six from "../Images/Strategies/06-competitor-analysis.png";
import seven from "../Images/Strategies/07-usability-testing.png";
import eight from "../Images/Strategies/08-gather-data-findings.png";
import nine from "../Images/Strategies/09-review-findings.png";
import ten from "../Images/Strategies/10-present-to-stakeholders.png";

export const strategies = [
  {
    number: "01",
    image: one,
    title: "Present To StakeHolders",
    title2: "What did we learn?",
    description:
      "After a thorough understanding of the product users, we can start noticing patterns through affinity mapping, journey mapping and problem statements. ",
  },
  {
    number: "02",
    image: two,
    title: "Present To StakeHolders",
    title2: "What did we learn?",
    description:
      "After a thorough understanding of the product users, we can start noticing patterns through affinity mapping, journey mapping and problem statements. ",
  },
  {
    number: "03",
    image: three,
    title: "Present To StakeHolders",
    title2: "What did we learn?",
    description:
      "After a thorough understanding of the product users, we can start noticing patterns through affinity mapping, journey mapping and problem statements. ",
  },
  {
    number: "04",
    image: four,
    title: "Present To StakeHolders",
    title2: "What did we learn?",
    description:
      "After a thorough understanding of the product users, we can start noticing patterns through affinity mapping, journey mapping and problem statements. ",
  },
  {
    number: "05",
    image: five,
    title: "Present To StakeHolders",
    title2: "What did we learn?",
    description:
      "After a thorough understanding of the product users, we can start noticing patterns through affinity mapping, journey mapping and problem statements. ",
  },
  {
    number: "06",
    image: six,
    title: "Present To StakeHolders",
    title2: "What did we learn?",
    description:
      "After a thorough understanding of the product users, we can start noticing patterns through affinity mapping, journey mapping and problem statements. ",
  },
  {
    number: "07",
    image: seven,
    title: "Present To StakeHolders",
    title2: "What did we learn?",
    description:
      "After a thorough understanding of the product users, we can start noticing patterns through affinity mapping, journey mapping and problem statements. ",
  },
  {
    number: "08",
    image: eight,
    title: "Present To StakeHolders",
    title2: "What did we learn?",
    description:
      "After a thorough understanding of the product users, we can start noticing patterns through affinity mapping, journey mapping and problem statements. ",
  },
  {
    number: "09",
    image: nine,
    title: "Present To StakeHolders",
    title2: "What did we learn?",
    description:
      "After a thorough understanding of the product users, we can start noticing patterns through affinity mapping, journey mapping and problem statements. ",
  },
  {
    number: "10",
    image: ten,
    title: "Present To StakeHolders",
    title2: "What did we learn?",
    description:
      "After a thorough understanding of the product users, we can start noticing patterns through affinity mapping, journey mapping and problem statements. ",
  },
];
